/* Reviewed logo-upload products only: native multipart submission preserves file bytes that Envy's
   text-only AJAX serializer would discard. Keep variant/quantity behavior. */
(() => {
  const input = document.querySelector('[data-mf-artwork-upload]');
  const form = input && input.form;
  if (!form || form.dataset.mfUploadReady) return;
  form.dataset.mfUploadReady = 'true';
  form.enctype = 'multipart/form-data';
  const checkFile = () => {
    const file = input.files && input.files[0];
    let message = '';
    if (file && file.size > 10 * 1024 * 1024) message = 'Please choose a file no larger than 10 MB.';
    else if (file && !/\.(png|jpe?g|pdf|svg)$/i.test(file.name)) message = 'Please choose a PNG, JPG, PDF or SVG file.';
    input.setCustomValidity(message);
    return !message;
  };
  input.addEventListener('change', checkFile);
  form.addEventListener('click', (event) => {
    const button = event.target.closest('#purchase');
    if (!button || button.form !== form) return;
    // Stop Envy's click handler, not the native submit default or validation.
    event.stopImmediatePropagation();
    checkFile();
  }, true);
  form.addEventListener('submit', (event) => {
    event.stopImmediatePropagation();
    if (!checkFile() || !form.reportValidity()) event.preventDefault();
  }, true);
})();
